import './index.scss';
import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    EMessageTypeGCO,
    EResponseFinishInteractionGCO,
    ITrackingGCO,
    ITrackingScreenGCO,
    UEventsGCO,
} from '../../../../models/Bills.interfaces';
import navigateParams from '../../../../utils/navigation/navigateParams';

const GcoFlow: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const webviewUrl = params.get('webviewUrl')!;
    const iframeRef: any = useRef(null);

    const manageEventTrackingGCO = (event: ITrackingGCO) => {
        const { message }: { message: any } = event;
        const { data }: ITrackingScreenGCO = message;
        if (data?.button_text?.toLocaleLowerCase() === 'volver') {
            sendToNative('/bills/gco-flow/feedback', 'feedback-info', '');
        }
    };

    const manageEventFlowGCO = (event: ITrackingGCO) => {
        const { message }: { message: any } = event;
        const { data }: ITrackingScreenGCO = message;

        if (
            data.result === EResponseFinishInteractionGCO.ERROR ||
            data.result === EResponseFinishInteractionGCO.SUCCESS
        ) {
            sendToNative('/bills/gco-flow/feedback', 'feedback-info', '');
        }
    };

    const manageMessageIframeGCO = (event: MessageEvent) => {
        const { data }: { data: UEventsGCO } = event;
        const { messageType } = data;
        switch (messageType) {
            case EMessageTypeGCO.TRACKING:
                // manageEventTrackingGCO(data);
                break;
            case EMessageTypeGCO.FLOW:
                manageEventFlowGCO(data);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        window.addEventListener('message', manageMessageIframeGCO);

        return () => {
            window.removeEventListener('message', manageMessageIframeGCO);
        };
    }, []);

    const sendToNative = (url: string, type: string, title: string, id?: string) => {
        iframeRef.current.style.display = 'none';
        const queryParams = {
            state: 'INFO',
            title: t('titleGcoFlow'),
            subtitle: t('subtitleGcoFlow'),
        };
        const storage = {};
        if (navigateParams(type, url, queryParams, storage, title)) {
            navigate(url);
        }
    };

    return (
        <div className='gcoFlow-page' ref={iframeRef}>
            <iframe src={webviewUrl} id='iframe'></iframe>
        </div>
    );
};

export default GcoFlow;
